import React, { useEffect, useState } from "react";
import {} from "@mui/icons-material";

import StatusWidget from "../ViewOrder/StatusWidget";
import { formatDecimal } from "../../../../hooks/Method";
import { action, controller } from "../../../../api/api";
import { Alert } from "../../../../layout";
import Actions from "./Actions";
import Header from "./Header";
import OrderWidget from "./Widgets/OrderWidget";
import FromWidget from "./Widgets/FromWidget";
import DateWidget from "./Widgets/DateWidget";
import CostWidget from "./Widgets/CostWidget";
import DynamicTable from "../../../../layout/DynamicTable/DynamicTable";

const Stocks = () => {
  const [stocks, setStocks] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setTblData([
      ...stocks.map((j) => ({
        ...j,
        order: (
          <OrderWidget
            orderNo={j.orderNo}
            deliveryDate={j.deliveryDate}
            isOverdue={j.isOverdue && (j.status === 4 || j.status === 1)}
          />
        ),
        from: <FromWidget company={j.supplierCompany} name={j.supplierName} />,
        orderStatus: (
          <StatusWidget
            status={j.status}
            isOverdue={j.isOverdue}
            className="!h-[25px]"
          />
        ),
        date: (
          <DateWidget createDate={j.createDate} updateDate={j.updateDate} />
        ),
        qty: (
          <span className="font-medium">
            {formatDecimal(j.totalQty || 0, true)}
          </span>
        ),
        cost: (
          <CostWidget
            paymentStatus={j.paymentStatus}
            totalDue={j.totalDue}
            totalOrderAmt={j.totalOrderAmt}
          />
        ),
      })),
    ]);
    return () => {};
  }, [stocks]);

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setStocks}
        endpointKey={controller.Stock + action.GetAllByOrgPg}
        ActionComp={(param) => <Actions {...{ param, setAlert, setStocks }} />}
        HeaderComp={() => <Header />}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "order", label: "Order" },
          { id: "from", label: "From" },
          { id: "recipientOutletName", label: "To" },
          { id: "orderStatus", label: "Status" },

          { id: "qty", label: "Total Qty" },
          { id: "cost", label: "Total Cost" },
          { id: "date", label: "Date Create/Update" },
        ]}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Stocks;
